import type { User } from '../../types';

export const HOME_SCHEDULE_ONBOARDING_ACCESS = 'home_schedule';

// Staff statuses with full platform access, identical to an active teacher.
// Mirrors isActiveStatus in firestore.rules — keep the two lists in lockstep.
export const FULL_ACCESS_STAFF_STATUSES = ['active', 'sub', 'inactive'];

export function hasFullPlatformStaffStatus(staffStatus: unknown): boolean {
  return typeof staffStatus !== 'string'
    || FULL_ACCESS_STAFF_STATUSES.includes(staffStatus.trim().toLowerCase());
}

export function hasOnboardingHomeScheduleAccess(user: User | null | undefined): boolean {
  return user?.role === 'teacher'
    && (user as any).onboardingAccess === HOME_SCHEDULE_ONBOARDING_ACCESS;
}

export function isHomeSchedulePath(pathname: string): boolean {
  return pathname === '/app/home' || pathname === '/app/squads';
}
